import { ReactNode, memo } from 'react';
import { UseFormRegister } from 'react-hook-form';
import TableRow from '../../TableRow/ui/TableRow';
import styles from './TableRows.module.scss';

interface ITableRowsProps {
  data: any[];
  columns: any[];
  rowActions: (classname: string, data?: any) => ReactNode;
  roundLastRow: boolean;
  rowHeight: string;
  register?: UseFormRegister<any>;
  tableKey?: string;
  onRowClick?: (data?: any) => void;
  selectable?: boolean;
  selectedRows?: string[];
}

/**
 * @param props - The props for the component.
 * @param columns - The columns array.
 * @param data - The table data
 * @param rowActions - Actions which is called if the user click to the row
 * @param roundLastRow - Indicates whether last row should be rounded
 * @param rowHeight - The row height
 * @param register - the path name to the form field value, name is required and unique
 * @param onClick - Function which is called after clicking table row
 * @param tableKey - The table row key
 * @returns A React component that displays the tab row.
 */

function TableRowsComponent(props: ITableRowsProps) {
  const {
    data,
    columns,
    rowActions,
    rowHeight,
    register,
    selectable,
    roundLastRow = false,
    selectedRows,
    tableKey,
    onRowClick,
  } = props;

  const renderRows = () => {
    return data.map((row, rowIndex) => {
      const rowKey = row?.id ?? rowIndex;
      return (
        <TableRow
          onClick={onRowClick}
          key={rowKey}
          columns={columns}
          selectedRows={selectedRows}
          rowActions={rowActions}
          data={{ ...row, rowIndex, tableKey }}
          rowHeight={rowHeight}
          register={register}
          selectable={selectable}
        />
      );
    });
  };
  return (
    <div
      className={[styles.rows, roundLastRow && styles.roundLastRow].join(' ')}
    >
      {renderRows()}
    </div>
  );
}

const TableRows = memo(TableRowsComponent);

export default TableRows;
